import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  activateButtonText: {
    description: 'Activate button text',
    defaultMessage: 'Activate {featureName}',
    id: 'EtPkhO',
  },
  viewDetailsButtonText: {
    description: 'View details button text',
    defaultMessage: 'View Details',
    id: 'OtRPp3',
  },
  disable: {
    description: 'Disable button text',
    defaultMessage: 'Disable',
    id: '4LD5aP',
  },
  cancel: {
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
    id: 'hHNj31',
  },
  close: {
    description: 'Close button text',
    defaultMessage: 'Close',
    id: '4BH2f8',
  },
  disableConfirmation: {
    description: 'Confirmation message for disabling a feature',
    defaultMessage: 'Are you sure you want to disable {featureName}?',
    id: 'T+8R4p',
  },
  sendFeedback: {
    description: 'Send feedback link text',
    defaultMessage: 'Send Feedback',
    id: 'oXFUHI',
  },
  learnMore: {
    description: 'Link text for learning more about a feature',
    defaultMessage: 'Learn more',
    id: 'oh5xqi',
  },
  featureEnabledSuccess: {
    description: 'Success message when a feature is enabled',
    defaultMessage: '{featureName} has been enabled successfully.',
    id: 'DIlPcS',
  },
  featureEnabledInline: {
    description: 'Inline success message shown in modal after enabling a feature',
    defaultMessage: 'Feature enabled!',
    id: 'azn7xR',
  },
  featureDisabledSuccess: {
    description: 'Success message when a feature is disabled',
    defaultMessage: '{featureName} has been disabled successfully.',
    id: '6r5vz+',
  },
  featureUpdateError: {
    description: 'Error message when feature update fails',
    defaultMessage: 'Failed to update feature setting. Please try again.',
    id: 'AeJuxX',
  },
  // Category labels for internationalization
  categoryInventory: {
    description: 'Inventory category label',
    defaultMessage: 'Inventory',
    id: 'YB02eR',
  },
  categoryWarehouse: {
    description: 'Warehouse category label',
    defaultMessage: 'Warehouse',
    id: 'lPMxa6',
  },
  categoryOrders: {
    description: 'Orders category label',
    defaultMessage: 'Orders',
    id: '0czDXf',
  },
  categoryProducts: {
    description: 'Products category label',
    defaultMessage: 'Products',
    id: 'm+FHRd',
  },
  categoryAutomationRules: {
    description: 'Automation category label',
    defaultMessage: 'Automation',
    id: 'ZkMfx1',
  },
  categorySupport: {
    description: 'Support category label',
    defaultMessage: 'Support',
    id: 'Z3isrl',
  },
  categoryAnalytics: {
    description: 'Analytics category label',
    defaultMessage: 'Analytics',
    id: 'nnUFq6',
  },
  labsPageTitle: {
    description: 'Labs page title',
    defaultMessage: 'Labs',
    id: 'Gc0x+K',
  },
  labsPageDescription: {
    description: 'Available early access features section description',
    defaultMessage: "Explore and test early versions of upcoming or experimental ShipStation features before they're officially released.",
    id: 'JduRYM',
  },
  labsWarningBanner: {
    description: 'Warning banner text for labs page',
    defaultMessage:
      'These features are currently in early access while we continue to refine them. Your feedback helps us improve, so please share your experience using the Send Feedback button.',
    id: 'zgMOog',
  },
  category: {
    description: 'Category column header',
    defaultMessage: 'Category',
    id: '+sf58m',
  },
  feature: {
    description: 'Feature column header',
    defaultMessage: 'Feature',
    id: 'qVqcgC',
  },
  statusIndicator: {
    description: 'Status of feature (active/inactive)',
    defaultMessage: 'Status',
    id: 'dd4q1u',
  },
  enabled: {
    description: 'Enabled status label',
    defaultMessage: 'Enabled',
    id: 'Yw0p7Y',
  },
  disabled: {
    description: 'Disabled status label',
    defaultMessage: 'Disabled',
    id: 'bOkLxz',
  },
  actionsHeader: {
    description: 'Actions column header for feature management',
    defaultMessage: 'Actions',
    id: '8mr/gQ',
  },
  noLabsFeaturesAvailableHeader: {
    description: 'Header displayed when no labs features are available from API',
    defaultMessage: 'No Labs features are currently available',
    id: '3MqxrA',
  },
  noLabsFeaturesAvailableDescription: {
    description: 'Description displayed when no labs features are available from API',
    defaultMessage: 'There are no experimental features available at this time. Check back later for new Labs features to try.',
    id: 'A1Q3Vs',
  },
  refreshingData: {
    description: 'Message shown when refreshing feature data in background',
    defaultMessage: 'Refreshing data...',
    id: 'fUFSw0',
  },
  errorLoadingFeatures: {
    description: 'Error message when loading Labs features fails',
    defaultMessage: 'Error loading Labs features',
    id: 'MtvZmj',
  },
  underMaintenance: {
    description: 'Label indicating a feature is under maintenance',
    defaultMessage: 'This feature is temporarily disabled while under maintenance.',
    id: 'pxSXl4',
  },
  openActionsMenu: {
    description: 'Aria label for the actions menu button on labs feature row',
    defaultMessage: 'Open actions menu',
    id: '8G//YP',
  },
});
